const name = 'checked'
const validator = (value, params) => value || params.companion

export default {
  name,
  validator
}
